import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { updatePageMeta } from '../utils/seo';
import { metaFor } from '../seo/routeMeta';
import { getCookieChoice, setCookieChoice } from '../utils/cookieConsent';
import './LegalPage.css';

/**
 * Cookie policy, with a working switch. The storage keys listed here are the
 * ones the client code actually sets (grep localStorage/sessionStorage). If you
 * add one, list it.
 */
function CookiePolicy() {
  const [choice, setChoice] = useState(null);

  useEffect(() => {
    updatePageMeta(metaFor('/cookie-policy'));
    setChoice(getCookieChoice());
  }, []);

  const choose = (c) => {
    setCookieChoice(c);
    setChoice(c === 'accepted' ? 'accepted' : 'rejected');
  };

  return (
    <div className="legal-page">
      <div className="lp-inner">
        <h1>Cookie Policy</h1>
        <p className="lp-date">Effective September 21, 2026</p>

        <p>Cookies and similar browser storage let the site remember things between pages. We use two kinds.</p>

        <h2>Needed for the site to work</h2>
        <p>These keep you signed in, remember a booking you started, and protect our forms from spam. They cannot be turned off here, because the site does not work without them.</p>
        <div className="lp-table">
          <table>
            <thead><tr><th>Name</th><th>Purpose</th></tr></thead>
            <tbody>
              <tr><td>token, user</td><td>Keeps you signed in to your portal</td></tr>
              <tr><td>trustedDeviceToken</td><td>Remembers a browser you trusted for two-factor sign-in</td></tr>
              <tr><td>bookingInProgress, customPackage, redirectAfterLogin</td><td>Holds a booking you started if you stop to sign in</td></tr>
              <tr><td>cookieConsent</td><td>Remembers your choice on this page</td></tr>
              <tr><td>urp_… preferences</td><td>Remembers small display choices, such as a dismissed tip</td></tr>
              <tr><td>Google reCAPTCHA</td><td>Tells people from bots on our forms</td></tr>
            </tbody>
          </table>
        </div>

        <h2>Analytics and ads</h2>
        <p>
          Google Analytics tells us how people find and use the site. Google Ads measurement tells us whether an ad led to a booking.
          Both set cookies, and both are optional.
        </p>
        <div className="lp-choice">
          <button type="button" className="btn btn-outline" onClick={() => choose('rejected')}>Turn off analytics &amp; ads</button>
          <button type="button" className="btn btn-primary" onClick={() => choose('accepted')}>Allow analytics &amp; ads</button>
        </div>
        <p className="lp-status" role="status">
          {choice === 'rejected' && 'Analytics and ads cookies are off in this browser.'}
          {choice === 'accepted' && 'Analytics and ads cookies are allowed in this browser.'}
          {!choice && 'You have not made a choice yet, so analytics and ads cookies are allowed.'}
        </p>
        <p>Your choice is saved in this browser only. Clearing your browser data resets it.</p>

        <h2>More</h2>
        <p>The <Link to="/privacy-policy">Privacy Policy</Link> explains what we collect and how to reach us.</p>
      </div>
    </div>
  );
}

export default CookiePolicy;
